<template>
  <div class="flexBox countdownFixedHeight">
    <!-- the container for the countdown title transition -->
    <div
      v-if="!isPreviewMode"
      class="countdownTitleContainer"
    >
      <!-- the transition wrapper that give us the rolling number effect -->
      <transition name="details-update">
        <!-- the context for the countdown (auction starts in... / selling in...) -->
        <div
          :key="countdownTitle"
          class="title paddingNormalRight"
        >
          {{ countdownTitle }}
        </div>
      </transition>
    </div>

    <!-- the container for the countdown clock itself -->
    <div
      v-if="!isPreviewMode"
      class="countdownClockContainer"
    >
      <!-- the bidding end time for the item has not yet been reached -->
      <div
        v-if="countdownClock.seconds_remaining > 0"
        class="countdownClockSubContainer"
      >
        <!-- the gradient along the top of the clock for fading to white -->
        <div class="countdownTopGradient" />

        <!-- the container for the clock readout of the time remaining.  it turns red when 12 of fewer seconds remain -->
        <div
          class="countdownClock"
          :class="{ colorError: countdownClock.seconds_remaining < 12 }"
        >
          <!-- the primary countdown unit container (days, hours, minutes)-->
          <div>
            <!-- the tens column -->
            <div class="countdownDigitContainer">
              <!-- wrap our column values in these transitions to give it the rolling effect -->
              <transition
                name="clock-movement"
                mode="out-in"
              >
                <!-- the content for the tens column for the primary units we are displaying -->
                <span
                  id="primaryTens"
                  :key="countdownClock.primary.tens"
                  class="digit"
                >

                  <!-- the previous value -->
                  <span v-html="countdownClock.primary.tensPrevious" />
                  <br>

                  <!-- the current value -->
                  <span v-html="countdownClock.primary.tens" />
                  <br>

                  <!-- the next value -->
                  <span v-html="countdownClock.primary.tensNext" />
                  <br>

                  <!-- the next next value -->
                  <span v-html="countdownClock.primary.tensNextNext" />
                </span>
              </transition>
            </div>

            <!-- the ones column -->
            <div class="countdownDigitContainer">
              <transition
                name="clock-movement"
                mode="out-in"
              >
                <span
                  id="primaryOnes"
                  :key="countdownClock.primary.ones"
                  class="digit"
                ><span v-html="countdownClock.primary.onesPrevious" /><br><span v-html="countdownClock.primary.ones" /><br><span v-html="countdownClock.primary.onesNext" /><br><span v-html="countdownClock.primary.onesNextNext" /></span>
              </transition>
            </div>

            <!-- the unit name (days, hours, minutes) -->
            <div class="countdownClockTitle">
              <transition
                name="clock-movement"
                mode="out-in"
              >
                <span
                  id="unitPrimary"
                  :key="countdownClock.primary.unitAbbr"
                  class="unit"
                ><span v-html="countdownClock.primary.unitPrevious" /><br><span v-html="countdownClock.primary.unit" /><br><span v-html="countdownClock.primary.unitNext" /><br><span v-html="countdownClock.primary.unitNextNext" /></span>
              </transition>
            </div>

            <!-- the abbreviated unit name (d, h, m) -->
            <!--
						<div class="countdownClockTitle hideOnDesktop">
							<transition name="clock-movement" mode="out-in">
								<span class="unit" id="unitAbbyPrimary" :key="countdownClock.primary.unitAbbr"><span v-html="countdownClock.primary.unitAbbrPrevious"></span><br /><span v-html="countdownClock.primary.unitAbbr"></span><br /><span v-html="countdownClock.primary.unitAbbrNext"></span><br /><span v-html="countdownClock.primary.unitAbbrNextNext"></span></span>
							</transition>
						</div>
						-->
          </div>

          <!-- the secondary countdown unit container (days, hours, minutes)-->
          <div>
            <!-- the tens column -->
            <div class="countdownDigitContainer">
              <transition
                name="clock-movement"
                mode="out-in"
              >
                <span
                  id="secondaryTens"
                  :key="countdownClock.secondary.tens"
                  class="digit"
                ><span v-html="countdownClock.secondary.tensPrevious" /><br><span v-html="countdownClock.secondary.tens" /><br><span v-html="countdownClock.secondary.tensNext" /><br><span v-html="countdownClock.secondary.tensNextNext" /></span>
              </transition>
            </div>

            <!-- the ones column -->
            <div class="countdownDigitContainer">
              <transition
                name="clock-movement"
                mode="out-in"
              >
                <span
                  id="secondaryOnes"
                  :key="countdownClock.secondary.ones"
                  class="digit"
                ><span v-html="countdownClock.secondary.onesPrevious" /><br><span v-html="countdownClock.secondary.ones" /><br><span v-html="countdownClock.secondary.onesNext" /><br><span v-html="countdownClock.secondary.onesNextNext" /></span>
              </transition>
            </div>

            <!-- the unit name -->
            <div class="countdownClockTitle">
              <transition
                name="clock-movement"
                mode="out-in"
              >
                <span
                  id="unitSecondary"
                  :key="countdownClock.secondary.unitAbbr"
                  class="unit"
                ><span v-html="countdownClock.secondary.unitPrevious" /><br><span v-html="countdownClock.secondary.unit" /><br><span v-html="countdownClock.secondary.unitNext" /><br><span v-html="countdownClock.secondary.unitNextNext" /></span>
              </transition>
            </div>

            <!-- the abbreviated unit name -->
            <!--
						<div class="countdownClockTitle hideOnDesktop">
							<transition name="clock-movement" mode="out-in">
								<span class="unit" id="unitAbbrSecondary" :key="countdownClock.secondary.unitAbbr"><span v-html="countdownClock.secondary.unitAbbrPrevious"></span><br /><span v-html="countdownClock.secondary.unitAbbr"></span><br /><span v-html="countdownClock.secondary.unitAbbrNext"></span><br /><span v-html="countdownClock.secondary.unitAbbrNextNext"></span></span>
							</transition>
						</div>
						-->
          </div>
        </div>

        <!-- the gradient along the bottom of the clock for fading to white -->
        <div class="countdownBottomGradient" />
      </div>

      <!-- the auction has started so show how many lots are remaining until we sell this item -->
      <div
        v-else-if="lotsRemaining > 1"
        class="countdownLotsRemainingContainer countdownMinHeight"
      >
        {{ lotsRemaining }} lot<span v-if="lotsRemaining > 1">s</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'Countdown',

  props: [
    'item_id'
  ],

  data () {
    return {
      setIntervalRunning: '',
    }
  },

  computed: {

	itemSoldStatus: function () {
		return this.$store.getters.itemSoldStatus(this.item_id)
	},

    lotsRemaining: function () {
		return this.$store.getters.lotsRemaining(this.item_id)
    },

	countdownTitle: function () {
		return this.$store.getters.countdownTitle(this.item_id)
	},

    countdownClock: function () {
		return this.$store.getters.countdownClock(this.item_id)
    },

	isPreviewMode: function () {
		return this.$store.getters.isPreviewMode(this.item_id)
    }

  },

  watch: {
  },

  mounted () {
  }

}

</script>

<style scoped>
</style>
